var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary","disabled":_vm.processando || !_vm.habilitado}},[(!_vm.processando)?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.processando)?_c('span',[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}),_vm._v("  PROCESSANDO")]):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b61075c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonSpinner.vue
// module id = 689
// module chunks = 30